import grispiApi from '../../apis/grispiApi';
import { Languages, languagesType } from '../../model/types';

export const getTranslateLanguages = async (language: languagesType): Promise<Languages> => {
    const response = await grispiApi.get(`/translate/languages?lang=${language}`);
    return response.data?.data?.languages?.map((lang) => {
        {
            return { value: lang.language, label: lang.name ?? lang.language };
        }
    });
};

export const getTranslatedText = async (text: string, targetLanguage: string): Promise<any> => {
    if (!text) return;
    const response = await grispiApi.post(`translate`, {
        q: text,
        target: targetLanguage,
        format: 'html'
    });
    return response.data.data.translations;
};
